// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1m81I","header":"ReportDetails_header__1DTRC","title":"ReportDetails_title__2dt-k","left":"ReportDetails_left__32VoI"};